export default {
      id: "arrow-big-usage",
      viewBox: "0 0 34 12",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#arrow-big",
      toString: function () {
        return this.url;
      }
    }